<template>
  <b-modal ref="student-data" id="student-data" hide-header hide-footer centered no-close-on-backdrop>
    <h4 class="purple mb-4">Editar dados</h4>
    <p>Altere os dados do usuário selecionado:</p>
    <b-row>
      <b-col class="mt-4">
        <b-form-group label="Nome">
          <b-form-input v-model="studentToEdit.user_name" type="text" placeholder=""></b-form-input>
        </b-form-group>
      </b-col>
      <b-col class="mt-4">
        <SelectClassrooms :value="studentToEdit.classroom_id" :callback="callbackClassrooms" :cycle="studentToEdit.cycle_id">
        </SelectClassrooms>
      </b-col>
      <div class="w-100"></div>
      <b-col class="mt-4">
        <b-form-group label="Ciclo">
          <b-form-input :value="getCycleName()" type="text" readonly
            placeholder="Ciclo será definido pela turma selecionada"
            style="background-color: #f8f9fa; cursor: not-allowed;"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col class="mt-4 status">
        <b-form-group label="Ativo">
          <b-form-checkbox v-model="studentToEdit.is_active" switch></b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col>
        <b-button class="btn large outline" @click="hideModal()">Voltar</b-button>
      </b-col>
      <b-col class="text-right">
        <b-button class="btn large blue" @click="update">Salvar</b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex'

import DataService from "@/services/students.service";
import httpRda from "../../http-rda";

import SelectClassrooms from "@/components/inputs/SelectClassrooms";
import moment from 'moment';

export default {
  name: "",
  components: {
    SelectClassrooms,
  },
  props: {
    student: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      studentToEdit: {},
      cycleDatesData: null,
      originalClassroomId: null,
      originalCycleId: null,
      cycles: [],
      classroomModal: null,
    };
  },

  watch: {
    student() {
      if (this.student) {
        this.studentToEdit = JSON.parse(JSON.stringify(this.student));
        this.originalClassroomId = this.student.classroom_id;
        this.originalCycleId = this.student.cycle_id;
      }
    },
  },

  async created() {
    await this.loadCycles();
  },

  methods: {
    ...mapActions({
      getStudents: 'community/listStudents',
    }),

    async loadCycles() {
      try {
        const response = await httpRda.get('/cycles');
        this.cycles = response.data.cycles || [];
      } catch (error) {
        this.cycles = [];
      }
    },

    getCycleName() {
      if (!this.studentToEdit.cycle_id || !this.cycles.length) {
        return 'Selecione uma turma';
      }

      const cycle = this.cycles.find(c => c.id === this.studentToEdit.cycle_id);
      return cycle ? cycle.name || cycle.designation : 'Ciclo não encontrado';
    },

    hideModal() {
      this.$refs["student-data"].hide();
    },

    async callbackClassrooms(args) {
      try {
        const selectedClassroom = await this.getClassroomInfo(args.id);
        this.classroomModal = selectedClassroom;
        const currentCycle = this.studentToEdit.cycle_id;
        const newCycle = selectedClassroom.cycle_id;
        const hasCycleChange = currentCycle !== newCycle;

        this.studentToEdit.classroom_id = args.id;

        if (hasCycleChange) {
          this.studentToEdit.cycle_id = newCycle;
        }
      } catch (error) {
        this.studentToEdit.classroom_id = this.originalClassroomId;
      }
    },

    async getClassroomInfo(classroomId) {
      try {
        const response = await httpRda.get(`/classrooms/${classroomId}`);
        return response.data.classroom || {};
      } catch (error) {
        this.$swal.fire({
          icon: "error",
          title: "Erro",
          text: "Não foi possível buscar informações da turma selecionada.",
          footer: "Por favor, tente novamente."
        });
        throw error;
      }
    },

    async showCycleDatesModal(cycleId) {
      const { value: formValues } = await this.$swal.fire({
        title: "Dados do Ciclo",
        html: `
      <div style="text-align: left;">
        <label for="began-at" style="display: block; margin-bottom: 5px; font-weight: bold;">Data de início no ciclo:</label>
        <input id="began-at" type="date" class="swal2-input" style="margin-bottom: 15px;" value="${moment(this.classroomModal.began_at).utcOffset(0).format('YYYY-MM-DD') || ''}">

        <label for="target-date" style="display: block; margin-bottom: 5px; font-weight: bold;">Expectativa de término do ciclo:</label>
        <input id="target-date" type="date" class="swal2-input" value="${moment(this.classroomModal.finished_at).utcOffset(0).format('YYYY-MM-DD') || ''}">
      </div>
    `,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonColor: "#68c5b7",
        cancelButtonColor: "#d33",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        preConfirm: () => {
          const beganAt = document.getElementById("began-at").value;
          const targetDate = document.getElementById("target-date").value;

          if (!beganAt || !targetDate) {
            this.$swal.showValidationMessage(
              "Por favor, preencha ambas as datas"
            );
            return false;
          }

          if (new Date(beganAt) >= new Date(targetDate)) {
            this.$swal.showValidationMessage(
              "A data de início deve ser anterior à data de término"
            );
            return false;
          }

          return {
            situation: 'regular',
            beganAt: beganAt,
            targetDate: targetDate,
            cycleId: cycleId
          };
        },
      });

      if (!formValues) {
        return false;
      }

      this.cycleDatesData = formValues;
      return true;
    },

    async saveCycleDates() {
      try {
        const cyclesPayload = {
          cycles: [
            {
              cycleId: this.cycleDatesData.cycleId,
              situation: this.cycleDatesData.situation,
              target_date: this.cycleDatesData.targetDate,
              began_at: this.cycleDatesData.beganAt,
              finished_at: null,
              subjects: [],
            },
          ]
        };

        await httpRda.post(
          `/cycle-situations/${this.studentToEdit.id}`,
          cyclesPayload
        );

        this.cycleDatesData = null;

      } catch (error) {
        this.cycleDatesData = null;
        throw error;
      }
    },

    async update() {
      try {
        const cycleChanged = this.originalCycleId !== this.studentToEdit.cycle_id;
        const classroomChanged = this.originalClassroomId !== this.studentToEdit.classroom_id;

        let cycleDatesConfirmed = true;

        if (cycleChanged || classroomChanged) {
          cycleDatesConfirmed = await this.showCycleDatesModal(this.studentToEdit.cycle_id);
        }

        if (cycleDatesConfirmed) {
          const data = {
            name: this.studentToEdit.user_name,
            classroom_id: this.studentToEdit.classroom_id,
            cycle_id: this.studentToEdit.cycle_id,
            is_active: this.studentToEdit.is_active,
          };

          await DataService.update(this.studentToEdit.id, data);

          if ((cycleChanged || classroomChanged) && this.cycleDatesData) {
            await this.saveCycleDates();
          }

          this.hideModal();
          this.getStudents();

          const Toast = this.$swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: "Estudante atualizado com sucesso!",
          });
        } else {
          this.studentToEdit.classroom_id = this.originalClassroomId;
          this.studentToEdit.cycle_id = this.originalCycleId;
        }
      } catch (error) {
        this.studentToEdit.classroom_id = this.originalClassroomId;
        this.studentToEdit.cycle_id = this.originalCycleId;

        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Não foi possível atualizar!",
          footer: "Por favor, verifique se os campos estão preenchidos.",
        });

        return error;
      }
    },
  }
}
</script>

<style lang="scss">
@import "@/assets/css/variables.scss";

div#student-data {
  .modal-dialog {
    max-width: 820px;

    .modal-content {
      background-color: $grey2;
      border: 0;
      border-radius: 0;

      .modal-body {
        padding: 60px;
      }
    }
  }

  .students {
    list-style: none;
    padding: 0;
    margin: 0;

    .student {
      align-items: center;
      display: flex;
      justify-content: space-between;
      line-height: 60px;
      border-bottom: 1px solid $grey5;

      &:last-child {
        border-bottom: 0;
      }

      .name {
        margin: 0;
      }

      .actions {
        a {
          margin: 0 15px;
        }
      }
    }
  }
}
</style>
